import Layout from 'components/Layout';
import LoadingSpinner from 'components/Shared/LoadingSpinner';

function LoadingState(): JSX.Element {
  return (
    <Layout title="" description="" indexed={false}>
      <div className="loading">
        <div className="spinner">
          <LoadingSpinner containerSize={64} spinnerSize={36} isWhite={false} />
        </div>
      </div>
      <style jsx>{`
        .loading {
          height: calc(100vh - 174px);
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .spinner {
          margin-bottom: 100px;
        }
      `}</style>
    </Layout>
  );
}

export default LoadingState;
